import TreeModelProvider from "@/utils/common/TreeModelProvider.ts";
import HierarchyFilterHelper from "@/utils/common/HierarchyFilterHelper.ts";
import {NaMaTreeNode, WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import {Ref, ref} from "vue";
import {QTreeNode} from "quasar";
import DTOCriteria = namaTypes.DTOCriteria;
import DTOExperssion = namaTypes.DTOExperssion;

export default class TreeViewPresenter {
  presenter: WidgetsPresenter;
  nodeSelectionEvent: Function;
  helper: HierarchyFilterHelper | undefined;
  treeModelProvider: TreeModelProvider | undefined;
  roots: Ref<QTreeNode<NaMaTreeNode>[]> = ref([]);
  expanded: Ref<string[]> = ref([]);
  selectedNodeId = ref<string | null | undefined>('');

  constructor(presenter: WidgetsPresenter, nodeSelectionEvent: Function) {
    this.presenter = presenter;
    this.nodeSelectionEvent = nodeSelectionEvent;
    this.helper = presenter.getHelperForTreeView();
    this.treeModelProvider = presenter.getTreeModelProviderForTreeView();
    this.selectedNodeId.value = presenter.fetchNodeIdFromPlace() ?? '';
  }

  parentsOf(nodeId: string) {
    let parents: string[] = [];
    for (let node of this.roots.value) {
      if (this.isOrContainsNode(node, nodeId, parents)) {
        break;
      }
    }
    return parents;
  }

  private isOrContainsNode(node: QTreeNode<NaMaTreeNode>, nodeId: string, parents: string[]) {
    if (nodeId === node.id) {
      return true;
    }
    if (node.children) {
      for (let child of node.children) {
        if (this.isOrContainsNode(child, nodeId, parents)) {
          parents.push(node.id!);
          return true;
        }
      }
    }
    return false;
  }

  async start() {
    if (this.treeModelProvider) {
      this.roots.value = await this.treeModelProvider.getNodes() ?? [];
      this.expanded.value = this.parentsOf(this.selectedNodeId.value ?? '');
    }
  }

  getCriteria(): DTOCriteria | undefined {
    if (this.helper) {
      let criteria: DTOCriteria = {};
      criteria.expressions = [];
      let selectedNodeExpressions: DTOExperssion[] = this.helper.createSelectedNodeExpressions(this.selectedNodeId.value);
      if (selectedNodeExpressions)
        criteria.expressions.push(...selectedNodeExpressions);
      //TODO :: treeFilter
      return criteria;
    }
    return undefined;
  }
}
